import { Box } from "@mui/material";
import usePlanner from "features/planner/state/usePlanner";
import useDeviceType from "hooks/useDeviceType";
import ProgramNameInput from "./ProgramNameInput";
import ProgramDateSelector from "./ProgramDateSelector";
import ClientNameInput from "./ClientNameInput";

export default function ProgramSettings() {
  const { programState, updateProgramField } = usePlanner();
  const { isLaptop } = useDeviceType();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: isLaptop ? "12px" : "16px",
        mt: isLaptop ? 1 : 2,
        mb: isLaptop ? 1 : 2,
        width: "100%",
        maxWidth: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "16px",
          width: "100%",
        }}
      >
        <Box sx={{ flex: "1 1 220px" }}>
          <ProgramNameInput />
        </Box>

        <Box sx={{ flex: "1 1 220px" }}>
          <ClientNameInput />
        </Box>
      </Box>

      {/* Fila inferior: Fechas */}
      <Box sx={{ width: "100%" }}>
        <ProgramDateSelector
          startDate={programState.startDate}
          endDate={programState.endDate}
          onChange={(field, value) => updateProgramField(field, value)}
        />
      </Box>
    </Box>
  );
}
